(function () {
  if (window.__sqCollectionRailTopLockV3) return;
  window.__sqCollectionRailTopLockV3 = true;

  function dedupeRails() {
    var rails = document.querySelectorAll('[data-sq-collection-rail]');
    for (var i = 1; i < rails.length; i += 1) {
      rails[i].remove();
    }
    return rails[0] || null;
  }

  function boot() {
    var rail = dedupeRails();
    if (!rail) return;

    var root = document.documentElement;
    var raf = 0;
    var anchor = null;
    var resizeObserver = null;

    function findAnchor() {
      return document.querySelector('#header-group .sq-navwrap') ||
        document.querySelector('.sq-navwrap') ||
        document.getElementById('header-group');
    }

    function visibleBottom(node) {
      if (!node) return 0;
      var rect = node.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;
      return Math.max(0, Math.min(window.innerHeight, Math.round(rect.bottom)));
    }

    function measure() {
      raf = 0;
      dedupeRails();
      var nextAnchor = findAnchor();
      if (nextAnchor !== anchor) {
        if (resizeObserver && anchor) resizeObserver.unobserve(anchor);
        anchor = nextAnchor;
        if (resizeObserver && anchor) resizeObserver.observe(anchor);
      }
      root.style.setProperty('--sq-collection-rail-lock-top', visibleBottom(anchor) + 'px');
    }

    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(measure);
    }

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(schedule);
    }

    var headerGroup = document.getElementById('header-group');
    if (window.MutationObserver && headerGroup) {
      new MutationObserver(schedule).observe(headerGroup, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }

    if (window.MutationObserver && document.body) {
      new MutationObserver(function (mutations) {
        var needsDedupe = mutations.some(function (mutation) {
          return mutation.addedNodes && mutation.addedNodes.length;
        });
        if (needsDedupe) {
          dedupeRails();
          schedule();
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    var scrollHost = document.querySelector('.page-wrapper');
    if (scrollHost) scrollHost.addEventListener('scroll', schedule, { passive: true });

    /* Interaction click ownership is handled by sq-sidebar-tree-controller-v2.js. */

    measure();
    [100, 350, 900, 1800].forEach(function (ms) { window.setTimeout(schedule, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
